export const REDIRECT_TO_SESSION_STORE_KEY = "redirect-to-after-login";
export const CENSIUS_EDIT_EXTRA_DAYS = 7;

// On ALF demo we are looking for 1/8 aide and 1/15 nurses (so for every 8 patients we need 1 aide)
export const ALF_DEMO_AIDE_RATIO = 8;
export const ALF_DEMO_NURSE_RATIO = 15;

// Longest allowed time-off span (leap-safe 1 year). Mirrors the backend's
// MAX_PREFERENCE_SPAN_DAYS so pickers reject over-long ranges before submit.
export const MAX_TIME_OFF_SPAN_DAYS = 366;

/** A department PPD target at or below this is the configuration's placeholder, not a target: the Day view shows none. */
export const DEFAULT_TARGET_PPD = 1;
